/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */

import React from 'react';
import c from 'classnames';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import TopNav from './TopNav';
import SubNav from './SubNav';
import Footer from './Footer';
import ChatBot from './ChatBot';
import chatBotStore from './chatbot/ChatBotStore';

// Main layout shell — composes TopNav + SubNav + content area
// expected props
// - menuItems (from App.js)
// - children (route content)
class MainLayout extends React.Component {
  getMenuItems() {
    return this.props.menuItems || [];
  }

  get chatbotEnabled() {
    return process.env.REACT_APP_ENABLE_CHATBOT === 'true';
  }

  render() {
    const chatOpen = this.chatbotEnabled && chatBotStore.isShowing;

    return (
      <div className="rmit-layout">
        <TopNav menuItems={this.getMenuItems()} />
        <SubNav menuItems={this.getMenuItems()} />
        <div className={c('rmit-main-row', { 'chatbot-open': chatOpen })}>
          <div className="mainLayout rmit-content animated fadeIn">
            {this.props.children}
          </div>
          {this.chatbotEnabled && <ChatBot />}
        </div>
        <Footer />
      </div>
    );
  }
}

export default inject('authentication', 'userStore', 'assets')(withRouter(observer(MainLayout)));
